// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["../../modules/request-for-quotation/assets/js/admin-panel/style-index"], () => (__webpack_require__("./modules/request-for-quotation/assets/src/js/admin-panel/index.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
